module.exports = __webpack_public_path__ + "static/media/April.8a978f1c.png";